import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLike = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
        <path
            fill="currentColor"
            d="M20 9h-5.612l1.123-3.367c.202-.608.1-1.282-.275-1.802A2.01 2.01 0 0 0 13.612 3H12c-.297 0-.578.132-.769.36L6.531 9H4c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h13.307a2.01 2.01 0 0 0 1.873-1.298l2.757-7.351A1 1 0 0 0 22 13v-2c0-1.103-.897-2-2-2M4 11h2v9H4zm16 1.819L17.307 20H8v-9.638L12.468 5h1.146l-1.562 4.683A.998.998 0 0 0 13 11h7z"
        />
    </svg>
);
export default SvgLike;
